import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, IconButton } from '@cbrebuild/blocks';

import Progress from '../../nucleus/progress/progress';

const isOfacFileName = filename => Boolean(filename && filename.toLowerCase().includes('ofac'));

const FileToUploadListItem = (props) => {
  const {
    file,
    onFileNameChange,
    onPrivacyChange,
    onExtractionOptInChange,
    onRemove,
    dealType,
    isEnhancedFlow,
    isUploading,
  } = props;
  const {
    name,
    uploadProgress,
  } = file;
  const isOfacDocument = isOfacFileName(name) || isOfacFileName(file.fileData && file.fileData.name);

  return (
    <React.Fragment>
      <li className="deal-file-upload__pending-file">
        <input
          onChange={e => onFileNameChange(e.target.value)}
          type="text"
          value={name}
          className="deal-file-upload__name-input"
        />
        <div className="file-item-actions">
          <Checkbox
            checked={file.isPrivate}
            onChange={({ target: { checked } }) => onPrivacyChange(checked)}
          >Private
          </Checkbox>
          {dealType === 'lease' && !isEnhancedFlow && file.fileData?.type === 'application/pdf' && !isOfacDocument && (
            <Checkbox
              checked={file.optInForExtraction}
              onChange={({ target: { checked } }) => onExtractionOptInChange(checked)}
            >Abstract this Lease
            </Checkbox>
          )}
          <IconButton
            iconName="close"
            onClick={onRemove}
            variant="basic"
          />
        </div>
      </li>
      {(isUploading && uploadProgress >= 0) && (
        <Progress progress={uploadProgress} />
      )}
    </React.Fragment>
  );
};

FileToUploadListItem.propTypes = {
  file: PropTypes.shape({
    fileData: PropTypes.shape({
      lastModified: PropTypes.number,
      lastModifiedDate: PropTypes.shape({}),
      name: PropTypes.string,
      size: PropTypes.number,
      type: PropTypes.string,
      webkitRelativePath: PropTypes.string,
    }),
    isPrivate: PropTypes.bool,
    name: PropTypes.string,
    uploadProgress: PropTypes.number,
    optInForExtraction: PropTypes.bool,
  }).isRequired,
  onFileNameChange: PropTypes.func.isRequired,
  onPrivacyChange: PropTypes.func.isRequired,
  onExtractionOptInChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  dealType: PropTypes.string,
  isEnhancedFlow: PropTypes.bool,
  isUploading: PropTypes.bool,
};

FileToUploadListItem.defaultProps = {
  dealType: null,
  isEnhancedFlow: false,
  isUploading: false,
};

export default FileToUploadListItem;
